import {RoleDto} from "./role.dto";
import {AuthModuleAccessEnum} from "../../../enum/auth-module-access-enum.enum";
import {DtoDetail} from "../../../../../core/shared/dto/dto.detail";

export class RoleAuthModuleDto extends DtoDetail{

    public roleDto? : RoleDto;
    public roleDtoId : number;
    public roleDtoName : string;
    public module: string;
    public accessEnum: AuthModuleAccessEnum;
    public configAccessEnum: AuthModuleAccessEnum;
    public maximumPaging: number;

}
